var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickBlueBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1202_14589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 0C11.663 0 0 11.663 0 26C0 40.337 11.663 52 26 52C40.337 52 52 40.337 52 26C52 11.663 40.337 0 26 0Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1776 20.4901L25.0941 34.5732C24.6716 34.9957 24.117 35.2083 23.5624 35.2083C23.0078 35.2083 22.4531 34.9957 22.0306 34.5732L14.9891 27.5316C14.1417 26.6846 14.1417 25.3151 14.9891 24.4681C15.8361 23.6207 17.2052 23.6207 18.0526 24.4681L23.5624 29.9779L36.1141 17.4266C36.9611 16.5792 38.3302 16.5792 39.1776 17.4266C40.0246 18.2736 40.0246 19.6427 39.1776 20.4901Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1202_14589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickBlueBg);
export default __webpack_public_path__ + "static/media/tick-blue-bg.99c8981ec529bfb3c52b4740634fe17a.svg";
export { ForwardRef as ReactComponent };